import { parse } from 'graphql';

import { createAuthenticatedGraphQLClient } from '../auth/createAuthenticatedGraphQLClient';
import type { RuntimeEnvironment } from '../graphql/config/runtimeConfig';
import type {
  CloneDoorVisitMutation,
  CloneDoorVisitMutationVariables,
} from '../graphql/queries/cloneDoorVisit.generated';

export type CloneDoorVisitClientOverrides = {
  env: RuntimeEnvironment;
  fetchImpl?: Parameters<typeof createAuthenticatedGraphQLClient>[0]['fetchImpl'];
};

// Keep this selection set in sync with cloneDoorVisit.graphql. Codegen emits
// operation types only, so this is the authenticated Field Ops document sent at runtime.
export const CLONE_DOOR_VISIT_MUTATION = parse(/* GraphQL */ `
  mutation CloneDoorVisit($doorVisitId: Int!, $requestId: ID!) {
    cloneDoorVisit(doorVisitId: $doorVisitId, requestId: $requestId) {
      doorVisitId
    }
  }
`);

export const cloneDoorVisit = async (
  doorVisitId: number,
  requestId: string,
  overrides: CloneDoorVisitClientOverrides,
): Promise<number> => {
  const client = createAuthenticatedGraphQLClient(overrides);
  const variables: CloneDoorVisitMutationVariables = { doorVisitId, requestId };
  const result = await client.request<CloneDoorVisitMutation>({
    document: CLONE_DOOR_VISIT_MUTATION,
    variables,
  });

  return result.cloneDoorVisit.doorVisitId;
};
